import { render } from "./CreateTestimonialDialog.vue?vue&type=template&id=07836322&scoped=true"
import script from "./CreateTestimonialDialog.vue?vue&type=script&lang=js"
export * from "./CreateTestimonialDialog.vue?vue&type=script&lang=js"

import "./CreateTestimonialDialog.vue?vue&type=style&index=0&id=07836322&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07836322"]])

export default __exports__